import React from 'react';
import Link from '@/_application/core/components/ui/link';
import {Image} from '@/_application/core/components/ui/image';
import {getImageAssetUrl} from '@/_application/core/utils/common';

function QualityCertificationBlock() {
    return (
        <div>
            <p className="text-[14px] font-bold uppercase leading-[19px] text-primary">Chứng nhận chất lượng</p>
            <Link
                href="http://online.gov.vn/Home/WebDetails/42263?AspxAutoDetectCookieSupport=1"
                target="_blank"
                className="transition-opacity hover:opacity-80">
                <Image
                    src={getImageAssetUrl('images/quality-certificate.png')}
                    alt="Quality Certificate"
                    width={176}
                    height={67}
                />
            </Link>
        </div>
    );
}

export default QualityCertificationBlock;
